/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Retention_7Inputs */

const da_privacy_retention_7 = /** @type {(inputs: Privacy_Retention_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sikkerhedskopier overskrives inden for 30 dage.`)
};

/** @type {(inputs: Privacy_Retention_7Inputs) => LocalizedString} */
const en_privacy_retention_7 = da_privacy_retention_7;

/**

* @param {Privacy_Retention_7Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_retention_7 = /** @type {((inputs?: Privacy_Retention_7Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Retention_7Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_retention_7(inputs)
	return /** @type {LocalizedString} */ ("Sikkerhedskopier overskrives inden for 30 dage.")
});